var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 56.4823,
    height: 56.4821,
    viewBox: "0 0 56.4823 56.4821",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7 3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.4823 0H0V56.4821H56.4823V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.0527 28.3388C41.8342 28.5743 41.6404 28.8318 41.4727 29.121C41.2354 29.5322 41.1976 29.9095 41.136 30.4631C41.1253 30.5568 41.1174 30.6511 41.1106 30.7449C41.1005 30.894 41.0954 31.0437 41.0954 31.1934V32.9742C41.0954 33.2352 41.0914 33.495 41.0784 33.7526C41.0411 34.488 40.9293 35.1991 40.6266 35.8548C40.6147 35.8797 40.6028 35.9045 40.591 35.9294C40.465 36.1869 40.3086 36.4349 40.1137 36.6721C39.8511 36.9924 39.572 37.2183 39.4077 37.3448C39.3969 37.3527 39.3868 37.3612 39.3772 37.3685C39.2603 37.4589 39.1207 37.5589 38.9581 37.6623C38.8135 37.7402 38.6423 37.8063 38.3916 37.8616H38.391C38.3328 37.8407 38.2803 37.8046 38.2396 37.7521C37.781 37.1658 36.9925 36.7489 36.5197 35.9898C35.9849 35.1319 35.5403 34.6885 35.1907 33.9429L35.376 33.6515C35.3511 33.6023 35.3376 32.9415 35.3376 32.8856V31.4334L35.3415 31.4204C35.9408 30.3394 36.7349 29.5712 37.524 29.0273C38.4023 28.4218 39.3981 28.0315 40.4351 27.8604C40.6345 27.8412 40.8333 27.8231 41.0287 27.8016C41.288 27.7734 41.5489 27.7593 41.811 27.7593C42.7503 27.7271 42.2555 28.1202 42.0527 28.3382V28.3388Z",
    fill: "url(#paint0_linear_0_60)",
    stroke: "url(#paint1_linear_0_60)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.1493 28.7178C24.358 28.9092 23.8338 29.2238 23.5136 29.4594C22.2348 30.3992 22.0145 31.6842 20.1918 35.32C19.9247 35.8526 19.8445 36.0045 19.6971 36.1949C18.7888 37.3646 17.379 38.0588 15.8766 38.0463C15.8506 38.0463 15.8246 38.0458 15.7987 38.0452L13.933 38C13.6388 37.9498 13.3507 37.869 13.0739 37.7566L14.9678 33.4645L17.6812 27.3147H17.6818C18.2042 26.5963 18.2551 26.2179 18.9831 25.8496C21.2475 24.7024 23.6966 26.498 25.1493 28.7178Z",
    fill: "url(#paint2_linear_0_60)",
    stroke: "url(#paint3_linear_0_60)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.2885 37.4358C39.2241 37.4889 39.1145 37.573 38.9694 37.6589C38.9287 37.6832 38.888 37.7097 38.8423 37.7283C38.6565 37.804 38.6277 37.8374 38.2797 37.9119C37.8793 37.9932 37.2743 38.0458 36.2481 38.0695C35.8595 38.078 35.5477 38.0797 35.3669 38.0802C34.8157 38.0802 34.4463 38.0695 34.0904 38.0695C33.4629 38.0695 32.1819 37.991 30.797 37.2917C29.4617 36.6179 28.6885 35.7006 28.3309 35.2132L25.556 30.2829C25.5119 30.2134 25.4718 30.1428 25.434 30.0699C25.2673 29.7497 25.0753 29.4306 24.8618 29.1199C23.4192 27.0227 20.9871 25.3266 18.738 26.4105C18.015 26.7584 17.9642 27.1159 17.4457 27.7943L17.5219 27.6293C19.3457 23.6931 24.2275 21.8953 28.3134 23.7372C28.3609 23.7586 28.4078 23.7807 28.4546 23.8021C29.8464 24.4618 30.9873 25.5175 31.7555 26.8036L35.2472 33.142L35.3635 33.3527L35.5375 33.6684C35.8335 34.2892 36.2192 34.9861 36.7231 35.7181C36.7654 35.7803 36.8089 35.8413 36.8519 35.9017C37.4161 36.6947 38.2888 37.2409 39.2749 37.4329L39.2891 37.4358H39.2885Z",
    fill: "url(#paint4_linear_0_60)",
    stroke: "url(#paint5_linear_0_60)",
    strokeWidth: 0.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.9291 38.0424C15.9116 38.0446 15.8941 38.0469 15.8766 38.048C15.6529 38.0729 15.4259 38.0836 15.1971 38.0785L14.9678 38.0734L14.5877 38.065C14.368 38.0599 14.1488 38.0401 13.933 38.0045C13.6388 37.9571 13.3507 37.8803 13.0739 37.7741C13.048 37.7645 13.0225 37.7543 12.9971 37.7442C12.9943 37.7425 12.9915 37.7413 12.9887 37.7402C12.9542 37.7261 12.9198 37.712 12.8859 37.6973C12.7848 37.6544 12.6865 37.6097 12.5905 37.5628C12.5893 37.5628 12.5876 37.5617 12.5865 37.5606C11.3834 36.9816 10.5475 36.1638 9.97138 35.3521C9.15125 34.1976 8.73385 32.8291 8.73385 31.4379V23.0108C11.1208 23.3542 12.9853 24.3427 13.9054 25.5147C14.8543 26.7234 14.9678 28.1891 14.9678 29.696V35.4702C14.9644 35.5312 14.9627 35.5928 14.9627 35.6543C14.9627 35.7159 14.9644 35.7775 14.9678 35.8385C15.013 36.684 15.3683 37.4521 15.9291 38.0424Z",
    fill: "url(#paint6_linear_0_60)",
    stroke: "url(#paint7_linear_0_60)",
    strokeWidth: 0.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.9778 23.0317C49.714 25.2763 48.7606 27.0306 47.6315 27.8954C47.3728 28.0936 47.1023 28.2529 46.8215 28.3811C45.8365 28.8307 44.7306 28.8951 43.6004 28.8951H42.8017C42.7514 28.8945 42.6938 28.8934 42.691 28.8951H41.6591C41.3925 28.8951 41.1264 28.9087 40.8627 28.9363C40.7192 28.951 40.5769 28.9702 40.4345 28.9934C39.3975 29.1606 38.4017 29.5418 37.524 30.1321C36.7349 30.663 35.9408 31.4125 35.3415 32.467C35.3404 32.4693 35.3387 32.4721 35.3376 32.4744V29.6254C35.3376 28.746 35.4985 27.8716 35.8346 27.0594C35.8516 27.0182 35.8691 26.977 35.8871 26.9363C36.1537 26.3269 36.4858 25.8106 36.8513 25.374C37.2563 24.89 37.7025 24.5031 38.1476 24.1952C39.2603 23.4237 40.5797 23.0311 41.8539 23.0311H49.9778V23.0317Z",
    fill: "url(#paint8_linear_0_60)",
    stroke: "url(#paint9_linear_0_60)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.759 22.6279C13.6747 22.6279 15.2276 21.0749 15.2276 19.1593C15.2276 17.2437 13.6747 15.6907 11.759 15.6907C9.8434 15.6907 8.29047 17.2437 8.29047 19.1593C8.29047 21.0749 9.8434 22.6279 11.759 22.6279Z",
    fill: "url(#paint10_linear_0_60)",
    stroke: "url(#paint11_linear_0_60)",
    strokeWidth: 0.24,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_60",
    x1: 36.0041,
    y1: 27.1283,
    x2: 41.8076,
    y2: 35.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#016C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#016F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#017A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#018B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0197A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#01AFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B4C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_60",
    x1: 35.1828,
    y1: 32.8093,
    x2: 42.3724,
    y2: 32.8093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_60",
    x1: 21.9428,
    y1: 38.3288,
    x2: 16.4143,
    y2: 28.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#01C3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#01B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#01A6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#028F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#027685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_60",
    x1: 13.0643,
    y1: 31.7701,
    x2: 25.1606,
    y2: 31.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_60",
    x1: 14.6346,
    y1: 23.6304,
    x2: 43.6314,
    y2: 37.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37FAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#35F8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#20DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ABAC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#01ACB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_60",
    x1: 17.4129,
    y1: 30.5461,
    x2: 39.3037,
    y2: 30.5461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37FAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#34F6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2DEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#24DEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#21DADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1AD0D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#08B6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01ACB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_60",
    x1: 12.3312,
    y1: 23.0114,
    x2: 12.3312,
    y2: 38.0802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_60",
    x1: 8.72707,
    y1: 30.5455,
    x2: 15.9432,
    y2: 30.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_60",
    x1: 35.3376,
    y1: 27.753,
    x2: 49.9778,
    y2: 27.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#016673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#02D0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#05D2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#32F1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44FDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_60",
    x1: 35.3308,
    y1: 27.7643,
    x2: 49.9857,
    y2: 27.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37FAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#34F6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2CEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#20D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0EBFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#01ACB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#00939E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_60",
    x1: 11.759,
    y1: 15.6907,
    x2: 11.759,
    y2: 22.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37FAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1CD2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01ACB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_60",
    x1: 8.28369,
    y1: 19.1593,
    x2: 15.2344,
    y2: 19.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EFCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.241C0 12.644 12.644 0 28.2411 0V0C43.8382 0 56.4823 12.644 56.4823 28.241V28.241C56.4823 43.8381 43.8382 56.4821 28.2411 56.4821V56.4821C12.644 56.4821 0 43.8381 0 28.241V28.241Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMark);
export default __webpack_public_path__ + "static/media/brand-mark.458d9cabd3e60782850ca21d28c6d758.svg";
export { ForwardRef as ReactComponent };